import * as apiService from "../api.service";
import { AssetDivision } from "@models/AssetDivision";
import { UpsertAssetDivisionError } from "./errors";
import { isAxiosError } from "axios";

export async function upsertAssetDivision(assetDivision: AssetDivision) {
	try {
		await apiService.PUT(`asset/division`, assetDivision);
	} catch (error) {
		if (isAxiosError(error) && error.response?.data.message) {
			throw new UpsertAssetDivisionError(error.response.data.message);
		}
		throw new UpsertAssetDivisionError();
	}
}
